import { useEffect, useState } from "react";
import "./styles.css";

import icon from "../../assets/iconwhats.png";

const CTAWpp = (props) => {
  const [text, setText] = useState("(11) 99999-9999");

  useEffect(() => {
    if (props.text !== undefined) setText(props.text);
  }, [props.text]);

  return (
    <button id="ctaWpp">
      <a
        href="http://wa.me/+5511999999999?text=Olá,%20Gostaria%20de%20saber%20mais"
        target="_blank"
        rel="noreferrer"
      >
        <figure>
          <img src={icon} alt="Ícone do Whatsapp" />
        </figure>
        <p>{text}</p>
      </a>
    </button>
  );
};

export default CTAWpp;
